





















import { Component, Vue, Inject } from 'vue-property-decorator';
import TableComponent from '@/components/Table/TableComponent.vue';
import { Filter, View, FetchedData } from '@/interfaces';
import { fetchFilesFromBucket } from '@/api/file';
import User from '@/models/User';

@Component({
  components: {
    TableComponent,
  },
})
export default class Files extends Vue {
  @Inject() user!: User;

  public subFilters: Filter[] = [];

  public data: FetchedData = {
    itemsLength: 0,
    items: [],
    views: [],
  };

  public isLoadingNewRecords = true;

  public defaultView: View = {
    name: 'Default',
    fields: [
      'File_Name',
      'Last_Modified',
      'Size',
    ],
    default: false,
    selected: true,
  };

  public notSortable: string[] = ['all'];

  async mounted(): Promise<void> {
    await this.fetchData();
  }

  public async fetchData(): Promise<void> {
    this.isLoadingNewRecords = true;
    const fetchedData = await fetchFilesFromBucket();
    this.data = fetchedData;
    this.isLoadingNewRecords = false;
  }
}
